/**
 * System banner entity actions — CRUD and active-banner fetch for the
 * system-wide notice feature. Backed by the odl-app /system-banners/ endpoint.
 */

import DOMPurify from 'dompurify';

import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Fetch Actions */

export function fetchSystemBanner(id) {
  return dispatch =>
    apiClient
      .get(`/odl-app/system-banners/${id}/`)
      .then(checkHttpStatus)
      .then(response => response.data)
      .catch(error => dispatch(genericErrorAction(error, 'FETCH_SYSTEM_BANNER')));
}

export function fetchActiveSystemBanner() {
  // Not dispatched through Redux — called directly by RequireAuth.
  return apiClient
    .get('/odl-app/system-banners/', { params: { 'filter[active]': 'true' } })
    .then(checkHttpStatus)
    .then(response => {
      const results = response.data?.payload?.results ?? [];
      return results.length > 0 ? results[0] : null;
    });
}

export function patchSystemBanner(id, values) {
  return dispatch =>
    apiClient
      .patch(`/odl-app/system-banners/${id}/`, {
        ...values,
        message: DOMPurify.sanitize(values.message),
      })
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'System Notice updated successfully',
            level: 'success',
            dismissible: true,
          }),
        );
        // SystemBannerViewSet composes RowWriteMixin (envelope="data"), so the
        // update echoes the row as {"data": row} — unwrap with no fallback.
        return response.data.data;
      })
      .catch(error => {
        dispatch(
          addToast({
            title: 'Error',
            message: 'An error has occurred.',
            level: 'error',
            dismissible: true,
          }),
        );
        return dispatch(genericErrorAction(error, 'EDIT_SYSTEM_BANNER'));
      });
}

export function createSystemBanner(values) {
  return dispatch =>
    apiClient
      .post('/odl-app/system-banners/', {
        ...values,
        message: DOMPurify.sanitize(values.message),
      })
      .then(checkHttpStatus)
      .then(response => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'System Notice created successfully',
            level: 'success',
            dismissible: true,
          }),
        );
        // SystemBannerViewSet composes RowWriteMixin (envelope="data"), so the
        // create echoes the row as {"data": row} — unwrap with no fallback.
        return response.data.data;
      })
      .catch(error => {
        dispatch(
          addToast({
            title: 'Error',
            message: 'An error has occurred.',
            level: 'error',
            dismissible: true,
          }),
        );
        return dispatch(genericErrorAction(error, 'CREATE_SYSTEM_BANNER'));
      });
}
